export default __webpack_public_path__ + "fonts/Roboto-400-cyrillic-ext8.woff2";